export const translation_12_1_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `위대한 여정`,
      typography_1: `그동안 다루었던 마음의 원리들을 되짚어보는 시간을 가지려 합니다. 변화를 향한 결심을 잃지 않고, 여기까지 온 스스로를 잠시 격려해주어도 좋을 것 같습니다.`,
      typography_2: `마음을 돌보는 일에 단숨에 고통을 없애줄 마법 같은 비법은 없습니다. 오히려 오랫동안 쓰지 않던 펌프를 누르면 처음엔 탁한 물이 쏟아져 나오듯, 억눌러둔 감정의 찌꺼기들이 한꺼번에 올라오기도 합니다. 하지만 이 낯설고 불편한 시간을 차분히 견뎌내면, 그 어떤 상황에도 쉽게 흔들리지 않는 단단한 내면을 마주하게 될 것입니다.`,
      typography_3: `마음을 들여다보다가 갑자기 혼란스럽고 부정적인 감정이 밀려오면 어떻게 대처해야 할까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_4: `정답은 B입니다. 오래된 펌프에서 처음엔 탁한 물이 나오듯, 낯설고 불편한 시간을 겪는 과정은 피할 수 없는 아주 자연스러운 현상입니다.`,

      typography_5: `마음의 선글라스`,
      typography_6: `마음이 지쳐 있을 때는 마치 시커먼 색안경을 끼고 세상을 보는 것과 같습니다. 모든 상황을 부정적으로 해석하는 쪽으로 뇌의 회로가 굳어져 있어서, 좋은 일을 겪어도 결국 불안과 무력감으로 이어지곤 합니다. 이때 머릿속에 떠오르는 자조적인 생각들을 절대적인 진실이라 믿고 스스로를 옭아매기 쉽습니다.`,
      typography_7: `하지만 머릿속에서 끊임없이 부정적인 말을 속삭이는 목소리는 '진짜 나'가 아닙니다. 그저 내 옆을 스쳐 지나가는 낯선 사람의 혼잣말 같은 하나의 소음일 뿐입니다. 이제 마음의 색안경을 벗고, 그 생각들이 결코 나 자신이 아님을 깨달아야 할 때입니다.`,
      typography_8: `머릿속에 스스로를 깎아내리는 비관적인 생각이 떠오를 때 어떻게 반응하는 것이 좋을까요?`,
      typography_9: `정답은 C입니다. 생각은 내 안에서 나온 진실이 아니라, 우연히 들려온 타인의 소음과 같습니다.`,

      typography_10: `신성한 멈춤`,
      typography_11: `감정은 너무나 순식간에 일어나서 미처 알아차리기도 전에 겉으로 튀어나오곤 합니다. 이런 무의식적인 반응의 고리를 끊어내려면 무엇보다 '잠시 멈추는 연습'이 필요합니다.`,
      typography_12: `이렇게 멈춰서는 순간, 비로소 내 마음을 한 걸음 떨어져서 바라볼 여유가 생깁니다. 갈등이 일어나는 순간에 지혜롭게 대처하려면, 평온한 일상 속에서 이 멈춤의 기술을 미리 연습해 두는 것이 좋습니다. 평소에 단련해 둔 '멈춤'은 거대한 스트레스 앞에서도 나를 지켜주는 훌륭한 방패가 됩니다.`,
      typography_13: `신성한 멈춤을 실천하기 위해 익혀야 할 핵심 기술 4단계는 무엇일까요?`,
      typography_14: `정답은 B입니다. 내 마음을 인지(R)하고, 있는 그대로 수용(A)하며, 호기심을 가지고 살펴본 뒤(I), 감정과 나를 동일시하지 않는(N) 'RAIN' 기법을 통해 감정에 휩쓸리지 않고 유연하게 대처할 수 있습니다.`,

      typography_15: `마음과 거리두기`,
      typography_16: `멈춤 이후에 본격적으로 해야 할 일은 '마음과 거리두기'입니다. 머릿속 생각과 감정을 남의 것처럼 떨어져서 바라보는 이 훈련은 앞서 말한 RAIN(인지, 수용, 관찰, 탈동일시)의 네 단계로 이루어집니다.`,
      typography_17: `마음에 거센 감정의 폭풍이 일 때마다 이 네 단계를 차분히 떠올려 보세요. 마음과 거리를 두는 일에 익숙해지면, 생각의 소용돌이 속에서도 내가 진정으로 원하는 삶의 방향을 선택할 수 있게 됩니다. 이는 오래된 나쁜 습관과 반응으로부터 스스로를 지켜내는 가장 강력한 무기가 되어줄 것입니다.`,
      typography_18: `RAIN 훈련을 통해 궁극적으로 다다르고자 하는 마음의 상태는 무엇일까요?`,
      typography_19: `정답은 C입니다. 억지로 긍정적인 생각만 하거나 머릿속을 완벽히 비우는 것은 불가능합니다. 떠오르는 생각과 유연하고 건강하게 관계를 맺는 것만이 정답입니다.`,

      typography_20: `다이얼 조절하기`,
      typography_21: `마음이 몹시 괴로울 때면 모든 감정을 단숨에 꺼버리는 전원 버튼을 누르고 싶어집니다. 하지만 부정적인 감정 이면에는 타인에 대한 공감 능력이나 삶을 책임감 있게 꾸려가려는 소중한 가치관이 함께 숨어 있습니다. 만약 버튼을 눌러 고통을 완전히 지워버린다면, 삶을 의미 있게 만들어주던 긍정적인 가치들마저 함께 잃게 될지도 모릅니다.`,
      typography_22: `그렇기에 감정을 완전히 끄는 '버튼' 대신, 감정의 크기를 조절하는 '다이얼'을 사용하는 법을 익혀야 합니다. 다이얼을 돌려 부정적인 감정이 주는 유익함은 남겨두되, 일상을 무너뜨리지 않을 정도로만 강도를 낮추는 것입니다. 나 자신을 잃지 않으면서도 감당할 수 있는 최적의 눈금을 찾는 것이 이 과정의 핵심입니다.`,

      typography_23: `새로운 관계`,
      typography_24: `우리를 진정으로 힘들게 하는 것은 슬픔이나 우울함 그 자체가 아닙니다. 감정을 대하는 서툰 방식이 우리를 더 깊은 수렁으로 빠뜨립니다.`,
      typography_25: `떠오르는 생각을 억지로 지우려 애쓰기보다는, 감정과 유연하게 관계 맺는 연습을 꾸준히 이어가 보세요. 이 여정을 끝까지 완주한다면, 그 어떤 시련 앞에서도 의연하게 내 삶을 이끌어갈 단단한 지혜를 얻게 될 것입니다.`,
    },
  },
};
